import { Step } from '@fcom/common/interfaces/step.interface';

import { VoluntaryChangeSteps, VoluntaryChangeErrorSteps } from './interfaces/step.interface';

export interface VoluntaryChangeStepperStep {
  step: Step;
  title?: string;
  ariaLabel: string;
}

export const VOLUNTARY_CHANGE_STEPS: VoluntaryChangeSteps = {
  SELECT_MATRIX: {
    id: 0,
    path: 'matrix',
    translationKey: 'checkPrices',
  },
  FLIGHT_SELECTION: {
    id: 1,
    path: 'flight-selection',
    translationKey: 'selectNewFlights',
  },
  PURCHASE_REVIEW: {
    id: 2,
    path: 'purchase-review',
    translationKey: 'review',
  },
  CHECKOUT: {
    id: 3,
    path: 'checkout',
    translationKey: 'payment',
  },
  PURCHASE_SUCCESS: {
    id: 4,
    path: 'confirmation',
    translationKey: 'confirmation',
  },
};

export const VOLUNTARY_CHANGE_ERROR_STEPS: VoluntaryChangeErrorSteps = {
  PAYMENT_ERROR: {
    path: 'payment/error',
  },
  ERROR: {
    path: 'error',
  },
  ERROR_ROUTE: {
    path: 'error/:error',
  },
};

export const VOLUNTARY_CHANGE_STEPS_ARRAY: Step[] = Object.keys(VOLUNTARY_CHANGE_STEPS)
  .filter((key) => !VOLUNTARY_CHANGE_STEPS[key].disabled)
  .map((key) => VOLUNTARY_CHANGE_STEPS[key]);

const getVoluntaryChangePhaseTitleKey = (step: Step): string =>
  `MMB.voluntaryChange.phases.title.${step.translationKey}`;

const VOLUNTARY_CHANGE_STEPPER_LABEL_KEY = 'MMB.checkIn.funnel.stepName';

export const VOLUNTARY_CHANGE_STEPPER_STEPS: VoluntaryChangeStepperStep[] = [
  VOLUNTARY_CHANGE_STEPS.SELECT_MATRIX,
  VOLUNTARY_CHANGE_STEPS.FLIGHT_SELECTION,
  VOLUNTARY_CHANGE_STEPS.PURCHASE_REVIEW,
].map((step) => ({
  step,
  title: VOLUNTARY_CHANGE_STEPPER_LABEL_KEY,
  ariaLabel: getVoluntaryChangePhaseTitleKey(step),
}));

export const getVoluntaryChangeStepperIndex = (currentStep: Step): number => {
  const activeStepIndex = VOLUNTARY_CHANGE_STEPPER_STEPS.findIndex(
    (stepperStep) => stepperStep.step.id === currentStep.id
  );

  return activeStepIndex === -1 ? 0 : activeStepIndex;
};
